var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsavm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16368 9.58789L5.57227 10.6123L25.8119 22.2972L26.4033 21.2728L6.16368 9.58789Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.98 22.3943C15.8777 22.3943 15.7755 22.3678 15.6839 22.3149L5.57266 16.4672C5.38982 16.3615 5.27724 16.1663 5.27734 15.9551C5.27741 15.7438 5.39013 15.5487 5.57303 15.4431L15.7125 9.58906C15.8956 9.48333 16.1211 9.48333 16.304 9.58906L26.161 15.2799C26.1662 15.2829 26.1713 15.2859 26.1763 15.2891L26.4303 15.446C26.6072 15.5554 26.7138 15.7498 26.7106 15.958C26.7075 16.1661 26.5952 16.3572 26.4149 16.4612L16.2757 22.3151C16.1842 22.3679 16.082 22.3943 15.98 22.3943ZM7.05084 15.9556L15.9802 21.1199L24.9454 15.9439L16.0083 10.7841L7.05084 15.9556Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.98 28.2249C15.8773 28.2249 15.7746 28.1981 15.6827 28.1448L5.57147 22.2656C5.38908 22.1595 5.277 21.9643 5.27734 21.7534C5.27765 21.5424 5.39033 21.3475 5.57303 21.2421L24.8851 10.0924L15.9669 4.95381L6.46015 10.4425V15.955H5.27734V10.101C5.27734 9.88969 5.39006 9.69442 5.57303 9.58884L15.6709 3.75891C15.8538 3.65333 16.079 3.65333 16.2618 3.75864L26.364 9.57946C26.5472 9.68498 26.6601 9.88024 26.6602 10.0916C26.6603 10.303 26.5476 10.4984 26.3644 10.604L7.04844 21.7561L15.981 26.95L25.5278 21.4381V15.9489H26.7107V21.7796C26.7107 21.9909 26.598 22.1862 26.4149 22.2919L16.2757 28.1456C16.1842 28.1985 16.082 28.2249 15.98 28.2249Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5989 4.27148H15.416V10.1014H16.5989V4.27148Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5714 21.8027H15.3887V27.6335H16.5714V21.8027Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsavm);
export default __webpack_public_path__ + "static/media/tsavm.4341716207a88fb79013ddf1bfef0325.svg";
export { ForwardRef as ReactComponent };